var _defs, _ellipse, _path, _line, _ellipse2, _path2, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningLightLamp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.33,
    height: 14.25,
    viewBox: "0 0 14.33 14.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lightning Light Lamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 7.32,
    cy: 9.36,
    rx: 4.59,
    ry: 4.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,6.7A4.43,4.43,0,0,1,8.05,4.62,4.16,4.16,0,0,1,12.16,6.7",
    transform: "translate(-0.74 -1)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.32,
    y1: 3.4,
    x2: 7.32
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 5.14,
    cy: 7.27,
    rx: 0.5,
    ry: 0.51
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-.93,8",
    transform: "translate(-0.74 -1)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.46,
    y1: 8.13,
    x2: 6.46,
    y2: 10.92
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.88,
    y1: 10.92,
    x2: 7.88,
    y2: 8.13
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.46,
    y1: 9.53,
    y2: 9.53
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.88,
    y1: 9.53,
    x2: 14.33,
    y2: 9.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningLightLamp);
export default __webpack_public_path__ + "static/media/LightningLightLamp.1349183f8519ffdce9f98cbccaac9020.svg";
export { ForwardRef as ReactComponent };